/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Vue, Component, Prop, Mixins,
} from 'vue-property-decorator';
import { ResultPageStatusEnum } from '@/components/result-page';
import { namespace } from 'vuex-class';
import { OrdersV2 } from '@/api/ordersV2/types';
import { HaiXiaoQueryStatusType } from '@/api/homeV2Status/types';
import { PreApplyItem } from '@/po/PreApplyItem';
import FinanceBusiness from '@/mixins/finance-business';
import ChangeChannelList from '@/components/change-channel';
import { isH5App } from '@/constant';
import { jumpToMarketPage } from '@/shared/utils/jumpToRedirectPage';
import { landData } from '@/shared/utils/landData';
import { OrderResultEnum } from '@/enums/orderV2';
import NewResultPage from '../new-result-page';
import { handleChannelClick } from '../../utils';
import '@/views_v2/home/store';

// 天下信用banner
// eslint-disable-next-line @typescript-eslint/no-unsafe-return
const TxxyBanner = () => import(
  /* webpackChunkName: "txxy-banner" */'../adv-txxy-banner/index.vue'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) as any;


const style = require('./index.module.scss') as Dictionary;

const ApplyResultStore = namespace('applyResult');
const HomeStore = namespace('home');
const HomeStoreNamespace = namespace('homeStore');

@Component
export default class ApplyFail extends Mixins(FinanceBusiness) {
  @Prop(String) readonly commodityId!: string;

  @ApplyResultStore.State orderDetail!: OrdersV2.OrderDetail | null;

  @HomeStore.Action getUserAutarkyState!: () => Promise<boolean>;

  /** 海消展示状态 */
  @HomeStoreNamespace.State haiXiaoQueryData!: HaiXiaoQueryStatusType | null;

  /** 是否显示老客升级入口 */
  @Prop(Boolean) readonly showUpgrade?: boolean;

  /** 去授信获取新额度 */
  private goPreApply() {
    this.$emit('goPreApply');
  }

  private get suggestionText(): string {
    const { lendFailedMsg, standardSuggestion } = this.orderDetail || {};
    let resaonText = '您的资质暂不符合';
    if (lendFailedMsg) {
      resaonText = lendFailedMsg;
    }
    if (standardSuggestion) {
      resaonText = standardSuggestion;
    }
    return this.showMoreChannel ? `${resaonText}，试试其他机构吧～` : resaonText;
  }

  /** 是否展示申请新额度按钮 */
  private btnShow = false;

  private async created() {
    // TODO: 外采流程中个性化配置，后续迁移到配置平台
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const pageConfig = await Vue.prototype.$tangram.getConfigValue({
      moduleCode: 'financial',
      keyCode: 'AppFinanceH5Web.flow.config',
    });
    const source = landData.getSouce();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const btnRes = (pageConfig[source] && pageConfig[source].applyResult) || {};
    if (source && btnRes) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      this.btnShow = btnRes.btn !== undefined ? btnRes.btn : true;
      return;
    }
    this.btnShow = true;
  }

  // 是否显示 文案：试试其他机构
  private showMoreChannel = false;

  private async mounted() {
    await this.getUserAutarkyState();

    if (this.showUpgrade) {
      this.$ubtModuleExposeNew('finance_withdrawResult_upgradeApply', {
        commodityId: this.commodityId,
        applyStatus: OrderResultEnum.LEND_FAILED,
      });
    }

    if (!this.showUpgrade) {
      this.$ubtModuleExposeNew('finance_withdrawResult_applyAmount', {
        commodityId: this.commodityId,
        applyStatus: OrderResultEnum.LEND_FAILED,
      });
    }

    this.$ubtModuleExposeNew('finance_withdrawResultSucceed_withdraw', {
      commodityId: this.commodityId,
      applyStatus: OrderResultEnum.LEND_FAILED,
    });
  }

  private renderFailMsg() {
    const { standardReason } = this.orderDetail || {};
    return (
      <div class={style.applyResult}>
        <div class={style.result}>
          <span>{standardReason ? `${standardReason}` : '抱歉，提现审核未通过'}</span>
        </div>

        <div class={style.suggestionText}>{this.suggestionText}</div>
      </div>
    );
  }

  private render() {
    return (
      <div class={style.applyFailed}>
        {// 挂载身份证清晰分不够弹窗 dom
        this.getUpdatedIdentityPhotoDialog()}
        <NewResultPage
          status={ResultPageStatusEnum.FAIL}
          statusText="提现失败"
          class={style.newResult}
        >
          {this.renderFailMsg()}
        </NewResultPage>

        {/* 内嵌协议 slot */}
        {this.$scopedSlots.contract && this.$scopedSlots.contract({})}
        {/* 分期申请状态轮询卡片 slot */}
        {this.$scopedSlots.mall && this.$scopedSlots.mall({})}

        <div class={style.content}>
          {/* 自营授信成功用户，隐藏按钮 */}
          {((!this.isAutarkySucceed() && this.btnShow)
          || (!this.haiXiaoQueryData?.hideApplyCreditEntry)) && (
            this.showUpgrade
              ? <div
              class={style.upgradeBanner}
              onClick={this.goPreApply.bind(this)}
              ></div>
              : <div class={style.newButtonWrap}>
              <div class={style.getNewCredit} onClick={this.onConfirm.bind(this)}>
                申请新额度
              </div>
            </div>
          )}
          {/* 复提推荐 */}
          <ChangeChannelList
            commodityId={this.commodityId}
            onReApply={this.onChannelClick.bind(this)}
            onShowChannel={this.showChannel.bind(this)}
            isNewChannel={true}
          />
          {/* 接入天下信用报告banner */}
          <TxxyBanner/>
        </div>
      </div>
    );
  }

  private onConfirm() {
    if (isH5App) {
      jumpToMarketPage();
    } else {
      // 申请新渠道 TODO(埋点编号录入)
      this.isNeedEducation('finance_ApplyResult_ReApplyCredit', ['产品', this.commodityId], true);
    }
  }

  private onChannelClick(channel: PreApplyItem) {
    handleChannelClick(this, channel, '臻有钱_提现失败_更换提现渠道', OrderResultEnum.LEND_FAILED);
  }

  private showChannel(show: boolean) {
    this.showMoreChannel = show;
  }
}
